import React, { useState } from 'react';
import { IconButton, Menu } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { GoToDetailsActionMenuItem } from './GoToDetailsActionMenuItem';
import { GoToEditActionMenuItem } from './GoToEditActionMenuItem';
import { useSelector } from 'react-redux';

const BusinessProfileActionsMenu = ({ businessProfile }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const user = useSelector((state) => state.org.org.user);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton id="action-icon-button" onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              boxShadow: '4px 4px 10px 0px rgba(0,0,0,0.2)',
            },
          },
        }}
      >
        <GoToDetailsActionMenuItem businessProfile={businessProfile} />
        {user?.permissions?.business_profiles === 2 && <GoToEditActionMenuItem businessProfile={businessProfile} />}
      </Menu>
    </>
  );
};

export default BusinessProfileActionsMenu;
